import { useState, useEffect } from 'react'
import './DashboardDropDownList.scss'

import {
    DropDownList,
    DropDownListChangeEvent,
    // DropDownsPopupSettings,
} from '@progress/kendo-react-dropdowns'

interface DashboardDropDownListProps {
    data: any[]
    selectedValue: any
    onSelectedValueChanged(selectedValue: any): void
    keyField?: string
    textField?: string
}

const DashboardDropDownList = (props: DashboardDropDownListProps) => {
    const [selectedValue, setSelectedValue] = useState<any>(null)
    // const [open, setOpen] = useState<boolean>(false)

    useEffect(() => {
        setSelectedValue(props.selectedValue)
    }, [props.selectedValue])

    const onChange = (event: DropDownListChangeEvent) => {
        setSelectedValue(event.target.value)
        props.onSelectedValueChanged(event.target.value)
    }

    // const onOpen = () => setOpen(true)

    // const onClose = () => setOpen(false)
    // const toggleDropdown = () => setOpen(!open)

    return (
        <div className="dashboard-drop-down">
            <DropDownList
                data={props.data}
                textField={props.textField}
                dataItemKey={props.keyField}
                value={selectedValue}
                onChange={onChange}
            />
            {/* <MultiSelect
                data={filteredData}
                dataItemKey={props.keyField}
                textField={props.textField}
                filterable={true}
                value={selectedValues}
                onChange={onChange}
                onFilterChange={filterChange}
                onOpen={onOpen}
                onBlur={onClose}
                opened={open}
                allowCustom={!!props.allowCustom}
                listNoDataRender={(element: React.ReactElement<HTMLDivElement>) => {
                    if (!!props.allowCustom) return null

                    return element
                }}
            />
            {!props.allowCustom && (
                <Button
                    iconClass="k-icon k-i-arrow-60-down"
                    onClick={toggleDropdown}
                    onBlur={onClose}
                />
            )} */}
        </div>
    )
}

export default DashboardDropDownList
